<template>
  <el-dialog ref="dialog" :title="title" v-model="isDialogShow" @open="initDialog" @close="closeDialog" :modal="false">
    <div class="ovf-hd m-b-10">
      <el-input v-model="searchUser" placeholder="请输入要搜索的用户名称" class="w-180" @change="changeSearchUser"></el-input>
      <el-select v-model="searchStruct" clearable placeholder="请选择部门" class="m-l-10" @change="changeSearchStruct">
        <el-option
          v-for="item in structData"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table ref="table" :data="tableData" v-loading="loading" height="300" highlight-current-row 
      @select="handleSelectionChange"
      @select-all="handleSelectionAll"
      @current-change="handleSingleChange">
      <el-table-column v-if="!isOnly || isOnly == 20" type="selection" width="55"></el-table-column>
      <el-table-column property="realname" label="姓名"></el-table-column>
      <el-table-column property="s_name" label="部门"></el-table-column>
    </el-table>
    <div slot="footer">
      <div v-show="!isOnly || isOnly != 10" class="fl m-b-5">
        <el-button @click="closeThis">确定</el-button>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
  import http from '../../../assets/js/http'

  export default {
    /*
     * @param dialogShow:  对话框显示开关
     * @param selectedPeople:  已选择人员（可能是选择范围，可能是默认人员）
     * @param selectedIds:  已选人员的id集合
     * @param title:  对话框标题
     * @param isOnly:  选择模式（可能的值为null,10,20）
     */
    props: ['dialogShow', 'selectedPeople', 'selectedIds', 'title', 'isOnly', 'structData'],
    data() {
      return {
        searchUser: '',
        searchStruct: '',
        loading: false,
        limit: 10,
        currentPage: 1,
        dataCount: null,
        tableData: []
      }
    },
    computed: {
      isDialogShow() {
        return this.dialogShow
      }
    },
    methods: {
      changeSearchUser(val) {
        this.searchStruct = val
        const data = {
          struct_id: this.searchStruct,
          keywords: this.searchUser,
          page: this.currentPage,
          limit: this.limit
        }
        this.getUsers(data)
      },
      changeSearchStruct(val) {
        this.searchStruct = val
        const data = {
          struct_id: this.searchStruct,
          keywords: this.searchUser,
          page: this.currentPage,
          limit: this.limit
        }
        this.getUsers(data)
      },
      filterData() {
        // 过滤数据，获取到用户数据之后调用，使已选的数据为勾选状态
        this.tableData.map((val) => {
          let index_ = _.indexOf(this.selectedIds, val.id)
          if (index_ > -1) {
            this.$refs.table.toggleRowSelection(val)
          }
        })
      },
      handleSelectionAll(selection) {
        // 全选函数
        if (!this.isOnly || this.isOnly == 20) {
          if (selection.length) {
            // 全选情况
            let data = []
            // selection 与 this.tableData相等，arr为在selection当中没有被选中的值
            let arr = _.difference(selection, this.selectedPeople)
            if (arr.length) {
              data = arr
            } else {
              data = selection
            }
            _(data).forEach((res) => {
              this.handleSelectedData(res)
            })
          } else {
            // 反选情况
            _(this.tableData).forEach((res) => {
              _(this.selectedPeople).forEach((res1, key1) => {
                if (res1) {
                  if (res.id == res1.id) {
                    this.selectedIds.splice(key1, 1)
                    this.selectedPeople.splice(key1, 1)
                  }
                }
              })
            })
          }
        }
      },
      handleSingleChange(row) {
        // 单选函数，只有在单选以及选择范围为不限时，选择“默认选中值”生效
        if (!this.isOnly || !row || this.isOnly == 20) {
          return
        }
        this.$emit('beforeSingleChange')    // 让父组件清空默认数据
        setTimeout(() => {
          this.handleSelectedData(row)
          this.closeThis()
        }, 0)
      },
      handleSelectionChange(selection, row) {
        this.handleSelectedData(row)
      },
      handleSelectedData(row) {
        if (!row) {
          return
        }
        const index = _.indexOf(this.selectedIds, row.id)
        if (index == -1) {
          this.selectedIds.push(row.id)
          this.selectedPeople.push(row)
        } else {
          this.selectedIds.splice(index, 1)
          this.selectedPeople.splice(index, 1)
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
        const data = {
          struct_id: this.searchStruct,
          keywords: this.searchUser,
          page: this.currentPage,
          limit: this.limit
        }
        this.getUsers(data)
      },
      getUsers(data) {
        this.loading = true
        this.apiGet(`admin/users?keywords=${data.keywords}&page=${data.page}&limit=${data.limit}&struct_id=${data.struct_id}`).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
            setTimeout(() => {
              this.filterData()
            }, 0)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      initDialog() {
        const data = {
          struct_id: this.searchStruct,
          keywords: this.searchUser,
          page: this.currentPage,
          limit: this.limit
        }
        this.getUsers(data)
        // 改变切换单选多选时表格的宽度
        setTimeout(() => {
          let tables = document.getElementsByTagName('table')
          _(tables).forEach((res) => {
            res.style.width = '100%'
          })
        }, 0)
      },
      closeThis() {
        this.$refs.dialog.close()
      },
      closeDialog() {
        // 用户触发父组件监听对话框关闭事件，构建 curInput.people_option
        this.$emit('closeDialog')
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// peopleSelect.vue?150461fc